export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./payments.vue?vue&type=template&id=7c7a0612"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/payments.vue?vue&type=template&id=7c7a0612
// module id = lIs/
// module chunks = 0